import MainLayout from '../../layouts/MainLayout';
import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { getObjects, searchPreps } from '@/helpers/api';
import SearchProducts from '../../components/forPages/search/SearchProducts';
import SelectSearch, { SelectedOptionValue} from 'react-select-search';
import CheckBox from '../../ui/CheckBox';
import { getLSRegion } from '@/store/ls/region';
import { optionsSearch } from '@/helpers/ost';
import useDeviceDetect from '../../helpers/hooks';
import LoadingText from "../../ui/LoadingText";
import { ISearchPrep } from '@/types/search';

const initialObjects = [
  {name: 'Все аптеки', value: 0}
]

export default function Search({
  prepsFromServer
}: {
  prepsFromServer: ISearchPrep[]
}){
  const router = useRouter();
  const search = router.query.search as string;

  const [objects, setObjects] = useState(initialObjects);
  const [preps, setPreps] = useState(prepsFromServer);
  const [object, setObject] = useState(initialObjects[0].value);
  const [synonims, setSynonims] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [sortByPrice, setSortByPrice] = useState(false);

  const isMounted = useRef(false);
  const { isMobile } = useDeviceDetect();

  const load = async (object: number, synonims_?: boolean, regionId?: number) => {
    setPreps([]);
    const s = synonims_ === undefined ? +synonims : +synonims_;
    setIsLoading(true);
    const preps = await searchPreps(search, object, s, regionId);
    setPreps(preps);
    setIsLoading(false);
  }

  useEffect(() => {
    const currentRegion = getLSRegion();
    getObjects(0, 0, currentRegion?.id).then(data => {
      const objects_ = data.map(item => ({name: item.obj_name + '\n' +item.obj_address, value: item.obj_id}));
      setObjects([...initialObjects, ...objects_]);
    })
    const objId = router.query.obj_id as string;
    if(objId) {
      document.getElementById('main-search')?.focus();
      setObject(+objId);
    }
    if(currentRegion) {
      load(object, synonims, currentRegion.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.obj_id])

  React.useEffect(() => {
    const currentRegion = getLSRegion();
    if(isMounted.current) {
      load(object, synonims, currentRegion?.id);
    } else {
      isMounted.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  const onSelectObject = async (value: SelectedOptionValue) => {
    const currentRegion = getLSRegion();
    setObject(+value);
    load(+value, synonims, currentRegion?.id);
  }

  const onSelectSynonims = (value: boolean) => {
    const currentRegion = getLSRegion();
    setSynonims(value);
    load(object, value, currentRegion?.id);
  }


  const renderTitle = () => {
    if(isLoading) return <LoadingText />;
    else if(!isLoading && search !== 'object') {
      if(preps.length > 0) return `Поиск: ${preps[0].tn}`;
      return `Поиск: ${search}`;
    }
    else return 'Введите поисковый запрос';
  }
  
  return <MainLayout>
    <Head>
      <meta name="robots" content="noindex, follow" />
    </Head>
    <Container>
      <div className="maxwidth">
        <RightColumn>
          <Title>
            {renderTitle()}
          
            <SelectSearch
              options={objects}
              search
              filterOptions={optionsSearch}
              placeholder="Выберите аптеку для поиска"
              onChange={onSelectObject}
              value={object.toString()}
            />

            <CheckBoxContainer>
              <CheckBox value={synonims} onChange={onSelectSynonims}>Показывать аналоги</CheckBox>
              {isMobile && <CheckBox value={sortByPrice} onChange={setSortByPrice}>По цене</CheckBox>}
            </CheckBoxContainer>

          </Title>

          {search !== 'object' && preps && (preps.length > 0) && <>
            <SearchProducts preps={preps} searchString={preps[0].tn} sortByPrice={sortByPrice} />

          </>}

          {search !== 'object' && !preps && <EmptyProducts>
            Загрузка ассортимента...
          </EmptyProducts>}

          {search !== 'object' && preps && (preps.length === 0) && !isLoading && <EmptyProducts>
            По данному запросу товаров не найдено. Попробуйте ввести другой запрос.
          </EmptyProducts>}
        </RightColumn>

      </div>
    </Container>
  </MainLayout>
}

export async function getServerSideProps(context) {
  if (context.params.obj_id) {
    return { props: {
      prepsFromServer: []
    }}
  } else {
    const preps = []; //await searchPreps(context.params.search, undefined, 1);
    return { props: {
      prepsFromServer: preps
    }}
  }
}

//{ index == 3 && <Banner src={BannerImage.src} key="banner" /> }


const CheckBoxContainer = styled.div`
  text-align: left;
  font-size: 18px;
  font-family: var(--font-regular);
  text-transform: initial;
  padding-top: 15px;

  @media (max-width: 750px) {
    display: flex;
    justify-content: space-between;
    padding-top: 13px;
    margin-bottom: 13px;
  }
`

const EmptyProducts = styled.div`
  white-space: normal;
`

export const TableString = styled.div<{ $blocked?: boolean }>`
  display: grid;
  grid-template-columns: 120px 3fr 1fr 120px 120px 70px;
  color: var(--color-title);
  font-size: 16px;
  line-height: 22px;

  ${p => p.$blocked && css`
    div:nth-child(5) {
      font-size: 0.875em;
      color: #9c8450;
      text-align: center;
    }
  `}
  & > div.hovered img {
    transform: scale(5) translateX(20%);
    z-index: 1000;
  }

  & > div:first-child img {
    object-fit: contain;
    transition: transform 0.3s;
  }
  &:not(.first-table-string) > div:first-child {
      position: relative;
      height: 120px;
  }

  & .sorting {
    cursor: pointer;
  }

  &:nth-child(2n+1) {
    background-color: #f3f6f760;
  }

  &.first-table-string {
    background-color: var(--color-bg-lightgray);
    text-transform: uppercase;
    font-family: var(--font-semibold);
  }

  & > div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 5px 25px 5px 20px;
  }


  & > div img {
    width: 30px;
    height: auto;
  }

`

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 80px 0 100px;

  & > div {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .filters-block {
    width: 25%;
  }

  @media (max-width: 750px) {
    padding: 20px 0 100px;

    & > div {
      flex-direction: column;
    }

    .filters-block {
      width: 100%;
      margin-bottom: 30px;
    }
  }




`


const RightColumn = styled.div`
  /* width: calc(75% - 60px); */
  width: 100%;
  position: relative;

  @media (max-width: 750px) {
    width: 100%;
    overflow-x: scroll;
    white-space: nowrap;
  }
`




const Title = styled.h2`
  font-size: var(--text-title);
  text-transform: uppercase;
  font-family: var(--font-semibold);
  color: var(--color-title);
  margin: 0 0 25px;

  & span {
    color: var(--green);
  }

  @media (max-width: 750px) {
    margin-bottom: 10px;
  }
`